/** Legacy category slug → Pilot v1 category display name */
const SLUG_TO_CATEGORY_NAME = {
  'free-range-birds': 'Country Chicken (Natukodi)',
  'better-than-broiler-chicken': 'BTB Chicken',
  eggs: 'Eggs',
  pickles: 'Pickles',
  mutton: 'Mutton',
  'village-birds': 'Country Chicken (Natukodi)',
  'Amma-Chethi-Marinades': 'Marinades',
  'country-catch': 'Country Catch',
  all: null,
};

/** Pilot category display name → legacy slug (for in-app links) */
const CATEGORY_NAME_TO_SLUG = {
  Eggs: 'eggs',
  Pickles: 'pickles',
  Mutton: 'mutton',
  'BTB Chicken': 'better-than-broiler-chicken',
  'Country Chicken (Natukodi)': 'village-birds',
  Marinades: 'Amma-Chethi-Marinades',
  'Country Catch': 'country-catch',
};

export function slugToCategoryName(slug) {
  if (!slug || slug === 'all') return null;
  return SLUG_TO_CATEGORY_NAME[slug] ?? null;
}

export function categoryNameToSlug(name) {
  if (!name) return 'all';
  return CATEGORY_NAME_TO_SLUG[name] ?? encodeURIComponent(name).replace(/%20/g, '-').toLowerCase();
}

/** Slug-shaped segments use lowercase letters, numbers, hyphens (legacy urlIds). */
export function looksLikeProductSlug(segment) {
  if (!segment || typeof segment !== 'string') return false;
  return /^[a-z0-9]+(?:-[a-z0-9]+)*$/i.test(segment) && segment.length < 80;
}

export function catalogCategoryQueryToSlug(searchParams) {
  const category = searchParams.get('category');
  if (!category) return 'all';
  const decoded = decodeURIComponent(category);
  return categoryNameToSlug(decoded);
}
